/**
 * BreadcrumbList JSON-LD builder for SEOHead.
 * Replaces the deprecated FAQPage schema (which Google has stopped showing
 * for non-government/medical sites since 2023-08).
 *
 * Usage:
 *   const BREADCRUMB = buildBreadcrumb([
 *     { name: '首頁', path: '/' },
 *     { name: '工具中心', path: '/tools' },
 *     { name: '539 開獎查詢', path: '/tools/539-history' },
 *   ]);
 *   <SEOHead jsonLd={[TOOL_SCHEMA, BREADCRUMB]} ... />
 */

const BASE_URL = 'https://cyxey.uk';

export interface BreadcrumbItem {
  name: string;
  /** Path starting with `/`. The function prepends BASE_URL automatically. */
  path: string;
}

export function buildBreadcrumb(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `${BASE_URL}${it.path}`,
    })),
  };
}
